"use client";

import { MainLink } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { floorPlanExamp } from "../../../../public/images/floor-plans";

const Intro = () => {
  const tH = useTranslations("home");
  const tC = useTranslations("common");

  return (
    <div className="from-background to-primary bg-gradient-to-t">
      <div className="gs--page-column pt-20 md:pt-24">
        <div className="grid items-center gap-10 md:grid-cols-[minmax(0,1fr)_minmax(280px,0.95fr)]">
          <div className="flex flex-col justify-center gap-5 text-white">
            <div className="flex flex-col gap-1">
              <h1 className="max-w-2xl text-5xl leading-[0.95] font-black tracking-normal uppercase sm:text-6xl lg:text-7xl">
                <span className="block">{tH("title")}</span>
                <span className="block">{tH("title2")}</span>
                <span className="block text-5xl leading-[0.95] font-extralight tracking-normal uppercase sm:text-6xl lg:text-7xl">
                  {tH("title3")}
                </span>
              </h1>
            </div>
            <p className="max-w-2xl text-lg sm:text-xl lg:text-2xl">
              {tH("description")}
            </p>
            <div className="flex w-full flex-col gap-4 sm:w-fit sm:min-w-80">
              <MainLink
                href={"/verkaufsoptimierte-grundrisse"}
                title={tC("salesOptimizedFloorPlans")}
              />
              <MainLink
                href={"/bemasste-grundrisse"}
                title={tC("sizedFloorPlans")}
              />
              <MainLink
                href={"/aufmass-service-vor-ort"}
                title={tC("measuringService")}
              />
            </div>
          </div>
          <Image
            className="mx-auto w-full max-w-[640px] md:justify-self-end"
            src={floorPlanExamp}
            alt={"Beispiel Grundrisse"}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;
